module.exports = __webpack_public_path__ + "static/item--ac--f8@3x.d173a647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f8@3x.png
// module id = 626
// module chunks = 126511778744290